import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStep3 = (state) => state.get('step3');

const makeSelectStep3 = () =>
  createSelector(selectStep3, (step3State) => ({
    abn: mapWithDefault(
      step3State,
      () => step3State.getIn(['form', 'abn']),
      ''
    ),
    claimITC: mapWithDefault(
      step3State,
      () => step3State.getIn(['form', 'claimITC']),
      ''
    ),
    nameOfBank: mapWithDefault(
      step3State,
      () => step3State.getIn(['form', 'nameOfBank']),
      ''
    ),
    branch: mapWithDefault(
      step3State,
      () => step3State.getIn(['form', 'branch']),
      ''
    ),
    bsbNumber: mapWithDefault(
      step3State,
      () => step3State.getIn(['form', 'bsbNumber']),
      ''
    ),
    accountNumber: mapWithDefault(
      step3State,
      () => step3State.getIn(['form', 'accountNumber']),
      ''
    ),
    accountHolder: mapWithDefault(
      step3State,
      () => step3State.getIn(['form', 'accountHolder']),
      ''
    ),
    registerForGSTPurpose: mapWithDefault(
      step3State,
      () => step3State.getIn(['form', 'registerForGSTPurpose']),
      ''
    ),
    percentageOfGST: mapWithDefault(
      step3State,
      () => step3State.getIn(['form', 'percentageOfGST']),
      ''
    ),
    bsbCannotBeVerified: mapWithDefault(
      step3State,
      () => step3State.getIn(['form', 'bsbCannotBeVerified']),
      ''
    ),
    isBsbValid: mapWithDefault(
      step3State,
      () => step3State.getIn(['form', 'isBsbValid']),
      ''
    ),
    otherInsurance: mapWithDefault(
      step3State,
      () => step3State.getIn(['form', 'otherInsurance']),
      ''
    ),
    provideDetails: mapWithDefault(
      step3State,
      () => step3State.getIn(['form', 'provideDetails']),
      ''
    ),
  }));

const makeSelectStep3Errors = () =>
  createSelector(selectStep3, (step3State) =>
    mapWithDefault(step3State, () => step3State.get('currentStep'), [])
  );

const makeSelectBsbValidating = () =>
  createSelector(selectStep3, (step3State) =>
    mapWithDefault(step3State, () => step3State.get('bsbValidating'), false)
  );

const makeSelectBsbNotice = () =>
  createSelector(selectStep3, (step3State) =>
    mapWithDefault(step3State, () => step3State.get('showBSBNotice'), false)
  );

export {
  makeSelectStep3,
  makeSelectStep3Errors,
  makeSelectBsbValidating,
  makeSelectBsbNotice,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step3/selectors.js